import axios from '@/server/request'

export default class api {
    /**
     * 获取城市列表-一维
     * @param {*} params
     */
    static getCityList(params) {
        return axios.post({
            url: '/common/getCityLevel',
            params
        })
    }

    /**
     * 按拼音获取城市列表-一维
     * @param {*} params
     */
    static getCityByPinyin() {
        return axios.get({
            url: '/common/getCityByPinyin'
        })
    }

    /**
     * 按拼音获取城市列表-一维
     * @param {
     *   keyword: 关键字
     * }
     *
     */
    static getAccountByKeyword(params) {
        return axios.get({
            url: '/common/wxAccountSearch',
            params
        })
    }

    /**
    * 浏览日志接口
    * @param
    *
    */
    static getYuntuLog(params) {
        return axios.post({
            url: '/user/yuntuLog',
            params
        })
    }

}
